import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"font-size":"var(--font-base)","letter-spacing":"-3%"} }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
    status: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const formattedStatus = computed<string>(() => {
  const rawStatus = props.status;
  if (!rawStatus) return '';
  return rawStatus.charAt(0) + rawStatus.slice(1).toLowerCase();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-nowrap d-flex align-items-center",
    style: _normalizeStyle({ color: __props.color })
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { style: {"margin-right":"0.25rem","width":"0.25rem","height":"0.25rem","min-width":"0.25rem","min-height":"0.25rem","background-color":"currentColor","border-radius":"100%"} }, null, -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(formattedStatus.value), 1)
  ], 4))
}
}

})